export default __webpack_public_path__ + "static/media/icon-clock-yellow.a66b5f8a.svg";